import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0",
    type: "button"
  }, [
    /*#__PURE__*/_createTextVNode(" Export "),
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" })
  ])
], -1)
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " Statut "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " # "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " code "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Mt CMD "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Mt DU "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Mise "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Epargne "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Reserve "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Tranche "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Actions ")
  ])
], -1)
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_10 = {
  key: 0,
  class: "badge text-bg-success fs-13"
}
const _hoisted_11 = {
  key: 1,
  class: "badge text-bg-danger fs-13"
}
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_21 = { class: "dropdown" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_23 = { class: "dropdown-menu" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_26 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_27 = {
  class: "modal fade createNewModal",
  id: "AddElementModal",
  tabindex: "-1",
  ref: "addElementModalRef",
  "aria-hidden": "true"
}
const _hoisted_28 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_29 = {
  key: 0,
  class: "modal-content p-15"
}
const _hoisted_30 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs mb-15 mb-md-20",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link active",
      id: "overviewPreview-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#overviewPreview-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "overviewPreview-tab-pane",
      "aria-selected": "true"
    }, " Commande ")
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link",
      id: "overviewCode-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#overviewCode-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "overviewCode-tab-pane",
      "aria-selected": "false",
      tabindex: "-1"
    }, " Reglements ")
  ])
], -1)
const _hoisted_32 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_33 = {
  class: "tab-pane fade active show",
  id: "overviewPreview-tab-pane",
  role: "tabpanel",
  tabindex: "0",
  "aria-labelledby": "overviewPreview-tab"
}
const _hoisted_34 = { class: "table-responsive" }
const _hoisted_35 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-15"
}, " Date vente : ", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-15"
}, " Client : ", -1)
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium text-paragraph fs-15" }
const _hoisted_39 = { class: "shadow-none lh-1 fw-medium text-paragraph fs-15" }
const _hoisted_40 = { class: "shadow-none lh-1 fw-medium text-paragraph fs-15" }
const _hoisted_41 = { class: "shadow-none lh-1 fw-medium text-paragraph fs-15" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("th", null, " Total ", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("th", null, " Total Sans Epargne ", -1)
const _hoisted_44 = {
  class: "tab-pane fade position-relative",
  id: "overviewCode-tab-pane",
  role: "tabpanel",
  tabindex: "0",
  "aria-labelledby": "overviewCode-tab"
}
const _hoisted_45 = { class: "table-responsive" }
const _hoisted_46 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-15 pt-0"
    }, " Date "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-15 pt-0"
    }, " Montant "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-15 pt-0"
    }, " Reste à payer ")
  ])
], -1)
const _hoisted_48 = { class: "shadow-none lh-1 fw-medium text-paragraph fs-15" }
const _hoisted_49 = { class: "shadow-none lh-1 fw-medium text-paragraph fs-15" }
const _hoisted_50 = { class: "shadow-none lh-1 fw-medium text-paragraph fs-15" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"text-align":"right !important"}
}, " Total Reglement", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"text-align":"right !important"}
}, " Total Restant Du", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close shadow-none",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_54 = {
  key: 1,
  class: "modal-content p-15 p-md-40"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h3", null, " Aucun reglement pour ce client ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_center = _resolveComponent("center")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          class: "search-box position-relative",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher un element"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _hoisted_3
        ], 32),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (ve, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_9, [
                    (_ctx.isReglementAJour(ve)[0])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, " A jour "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, " Non a jour "))
                  ]),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(ve.client.code), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(ve.montant), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(ve.montant - _ctx.isReglementAJour(ve)[1]), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(ve.mise), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(ve.epargne), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString((_ctx.isReglementAJour(ve)[1] % ve.mise)), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(Math.floor(_ctx.isReglementAJour(ve)[1] / ve.mise)), 1),
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("ul", _hoisted_23, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#AddElementModal",
                            onClick: ($event: any) => (_ctx.getOne(ve.id, ve.client.code))
                          }, [
                            _hoisted_25,
                            _createTextVNode(" Détails ")
                          ], 8, _hoisted_24)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        (_ctx.element.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("table", _hoisted_35, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _hoisted_36,
                            _createElementVNode("td", null, _toDisplayString(_ctx.vente ? _ctx.format_Date(_ctx.vente.dateVente) : '-'), 1),
                            _hoisted_37,
                            _createElementVNode("td", null, _toDisplayString(_ctx.vente ? _ctx.vente.client.nom+ ' '+ _ctx.vente.client.prenoms : '-'), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vente?.prodCondVentes, (pro, indexx) => {
                            return (_openBlock(), _createElementBlock("tr", { key: indexx }, [
                              _createElementVNode("td", _hoisted_38, _toDisplayString(indexx + 1), 1),
                              _createElementVNode("td", _hoisted_39, _toDisplayString(pro.nomComplet), 1),
                              _createElementVNode("td", _hoisted_40, _toDisplayString(pro.qteVendu) + " x " + _toDisplayString(pro.prix), 1),
                              _createElementVNode("td", _hoisted_41, _toDisplayString(pro ? pro.montant : "-"), 1)
                            ]))
                          }), 128)),
                          _createElementVNode("tr", null, [
                            _hoisted_42,
                            _createElementVNode("td", null, _toDisplayString(_ctx.vente ? _ctx.vente.montant : ""), 1),
                            _hoisted_43,
                            _createElementVNode("td", null, _toDisplayString(_ctx.vente ? _ctx.vente.montantSansEpargne : ""), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("table", _hoisted_46, [
                        _hoisted_47,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.element, (e, inde) => {
                            return (_openBlock(), _createElementBlock("tr", { key: inde }, [
                              _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.format_Date(e.dateReglement)), 1),
                              _createElementVNode("td", _hoisted_49, _toDisplayString(e.montant), 1),
                              _createElementVNode("td", _hoisted_50, _toDisplayString(e.restAPayer), 1)
                            ]))
                          }), 128)),
                          _createElementVNode("tr", null, [
                            _hoisted_51,
                            _createElementVNode("td", null, [
                              _createElementVNode("b", null, [
                                _createElementVNode("h6", null, _toDisplayString(_ctx.totalReg), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_52,
                            _createElementVNode("td", null, [
                              _createElementVNode("b", null, [
                                _createElementVNode("h6", null, _toDisplayString(_ctx.vente ? _ctx.vente.montant - _ctx.totalReg : "-"), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_53
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_54, [
              _createVNode(_component_center, null, {
                default: _withCtx(() => [
                  _hoisted_55
                ]),
                _: 1
              })
            ]))
      ])
    ], 512)
  ], 64))
}